module.exports = "<div class=\"popover fade {{placement}} {{sizeClass}}\" role=\"tooltip\" id=\"{{id}}\" [ngStyle]=\"style\" [ngClass]=\"{'in': isPopoverOpen}\" (click)=\"onPopoverClick()\">\n    <div class=\"arrow\" [ngStyle]=\"{'left': arrowLeft}\"></div>\n    <h3 class=\"popover-title\">\n        <ng-content select=\"[popover-title]\"></ng-content>\n    </h3>\n    <div class=\"popover-content\">\n        <ng-content select=\"[popover-content]\"></ng-content>\n    </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/popover/popover.component.html
// module id = ../../../../../src/app/components/popover/popover.component.html
// module chunks = main